<div class="comments">
    <h3 class="comments-title">Comentarios</h3>
    <div class="alert alert-primary" role="alert">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span class="comments-caveat"> Al dejar un comentario se mantendrán en privacidad el correo electrónico y apellidos.</span>            
    </div>
    <app-comment-form submitLabel="Comentar" (handleSubmit)="addComment({info: $event, parentId: null})">
    </app-comment-form>
    <div class="comments-container">
        <app-comment *ngFor="let rootComment of getRootComments()" [comment]="rootComment"
            [replies]="getReplies(rootComment.id)" [activeComment]="activeComment"
            (setActiveComment)="setActiveComment($event)" (addComment)="addComment($event)"
            (updateComment)="updateComment($event)" (deleteComment)="deleteComment($event)"
            [currentUserId]="currentUserId">
        </app-comment>
    </div>
</div>